import { ref, onMounted } from 'vue';
const mapRef = ref(null);
const mapInitialized = ref(false);
const map = ref(null);
export const useMap = () => {
	onMounted(() => {
		mapRef.value.$mapPromise.then((gmap) => {
			map.value = gmap;
			mapInitialized.value = true;
		});
	});

	return {
		map,
		mapRef,
		mapInitialized
	};
};
